module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@2x-aabcc503585a9c53ac1838efd522e1e5.png";